export interface IconStepperCompletedProps extends React.SVGProps<SVGSVGElement> {
    hasError?: boolean;
}

export const IconStepperCompleted = ({ hasError, ...rest }: IconStepperCompletedProps) => {
    return (
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <circle cx="4" cy="4" r="4" fill={hasError ? "#FA5252" : "#30A9D4"} />
        </svg>
    );
};
